/* import __COLOCATED_TEMPLATE__ from './market-input-time-picker.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
const TimeRegExp24Hour = /(?<hour>^[01]?\d|2[0-4]):(?<minute>[0-5]\d$)/;
/**
 * Parse a formatted time string using a 24-hour clock.
 * This returns null when the string format does not match `timeRegExp24Hour`
 *
 * 00:00 => { hour: 0, minute: 0 }
 * 06:30 => { hour: 6, minute: 30 }
 * 12:00 => { hour: 12, minute 0 }
 * 18:30 => { hour: 18, minute 30 }
 *
 * @param displayValue The displayed time
 * @returns The parsed time
 */
export function parseTime24Hour(displayValue) {
  const match = displayValue.match(TimeRegExp24Hour);
  if (match?.groups) {
    const hour = Number.parseInt(match.groups.hour, 10) % 24;
    if (hour < 0 || hour > 23) {
      return null;
    }
    return {
      hour,
      minute: Number.parseInt(match.groups.minute, 10)
    };
  }
  return null;
}
let MarketInputTimePicker = (_class = class MarketInputTimePicker extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  /**
   * The value of the time input is always in 24-hour format that includes leading zeros: hh:mm,
   * regardless of the input format, which is likely to be selected based on the user's locale
   * (or by the user agent)
   *
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/time#time_value_format
   */
  get inputValue() {
    const {
      value
    } = this.args;
    if (!value) {
      return '';
    }
    const options = {
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    };
    // the month-day-year doesn't matter since we're only formatting time
    const instant = new Date();
    instant.setHours(value.hour);
    instant.setMinutes(value.minute);
    return this.intl.formatTime(instant, options);
  }
  setTime(event) {
    const displayTime = event.detail.value;
    const value = parseTime24Hour(displayTime);
    this.args.onChange(value);
  }
  onBlur() {
    this.args.onBlur && this.args.onBlur();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBlur", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBlur"), _class.prototype), _class);
export { MarketInputTimePicker as default };